module.exports = __webpack_public_path__ + "img/cartao_jcb.0f331998.svg";